

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {FlexLayoutModule} from "@angular/flex-layout";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {FuseSharedModule} from "../../../@fuse/shared.module";
import {FuseSidebarModule} from "../../../@fuse/components";
import {MatRippleModule} from "@angular/material/core";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatSelectModule} from "@angular/material/select";
import {MatDialogModule} from "@angular/material/dialog";
import {MatToolbarModule} from "@angular/material/toolbar";
import {RouterModule} from "@angular/router";
import {MatTreeModule} from "@angular/material/tree";
import {TranslateModule} from "@ngx-translate/core";
import {MatTabsModule} from "@angular/material/tabs";
import {TrainingComponent} from "./training.component";
import {CommonModule} from "@angular/common";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {ServiceNotSelectedDialogComponent} from "./dialog/serviceNotSelectedDialog/serviceNotSelectedDialog.component";
import {CardAlreadyRegisteredDialogComponent} from "./dialog/cardAlreadyRegisteredDialog/cardAlreadyRegisteredDialog.component";
import {ServiceUnavailableDialogComponent} from "./dialog/serviceUnavailableDialog/serviceUnavailableDialog.component";
import {ConfirmParticipationDialogComponent} from "./dialog/confirmParticipationDialog/confirmParticipationDialog.component";
import {SelectIncomingTrainingDialogComponent} from "./dialog/selectIncomingTrainingDialog/selectIncomingTrainingDialog.component";
import {TrainingDetailsComponent} from "./trainingDetails.component";
import {ChartsModule} from "ng2-charts";
import {TrainingListModalComponent} from "./trainingListModal.component";
import {TrainingDetailsModalComponent} from "./trainingDetailsModal.component";
import {SafePipe} from "../pipes/safe.pipe";
import {MatTooltipModule} from "@angular/material/tooltip";
import {CardNotFoundDialogComponent} from "./dialog/cardNotFoundDialog/cardNotFoundDialog.component";

@NgModule({
    declarations: [
        TrainingComponent,
        TrainingDetailsComponent,
        TrainingListModalComponent,
        TrainingDetailsModalComponent,
        SafePipe,
        ServiceNotSelectedDialogComponent,
        CardAlreadyRegisteredDialogComponent,
        ServiceUnavailableDialogComponent,
        ConfirmParticipationDialogComponent,
        SelectIncomingTrainingDialogComponent,
        CardNotFoundDialogComponent,
    ],
    imports: [
        RouterModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        FlexLayoutModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,

        FuseSharedModule,
        FuseSidebarModule,
        MatRippleModule,
        MatCheckboxModule,
        MatSelectModule,
        MatDialogModule,
        MatToolbarModule,
        MatTreeModule,
        TranslateModule,
        MatTabsModule,
        CommonModule,
        MatProgressSpinnerModule,
        ChartsModule,
        MatTooltipModule,
    ],
    providers: [
    ],
    bootstrap: [
        TrainingComponent,
        ServiceNotSelectedDialogComponent,
        CardAlreadyRegisteredDialogComponent,
        ServiceUnavailableDialogComponent,
        ConfirmParticipationDialogComponent,
        CardNotFoundDialogComponent,
    ]
})
export class TrainingModule { }
